import * as React from 'react';

export function PlayCircleSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx={10.982} cy={11.132} r={10.574} fill="#fff" fillOpacity={0.22} />
      <path d="M7.982 5.883v10.5l8.25-5.25-8.25-5.25z" fill="#fff" />
    </svg>
  );
}
